import { CheckCircle2 } from "lucide-react";

const TEMPLATES = [
  { id: "centered", name: "Default", desc: "Centered, sans-serif, ATS-friendly" },
  { id: "modern", name: "Modern", desc: "Two-column sans-serif" },
  { id: "classic", name: "Traditional", desc: "Centered serif, classic look" },
];

export const ACCENT_COLORS = [
  { id: "slate", name: "Slate", hex: "#0f172a" },
  { id: "blue", name: "Blue", hex: "#2563eb" },
  { id: "emerald", name: "Emerald", hex: "#059669" },
  { id: "burgundy", name: "Burgundy", hex: "#9f1239" },
  { id: "amber", name: "Amber", hex: "#b45309" },
  { id: "plum", name: "Plum", hex: "#6d28d9" },
];

export default function TemplatePicker({ value, onChange, accentColor, onAccentChange }) {
  return (
    <div data-testid="template-picker">
      <div className="text-xs uppercase tracking-widest text-slate-500 font-mono-display mb-3">Layout</div>
      <div className="grid grid-cols-1 gap-2">
        {TEMPLATES.map((t) => {
          const active = value === t.id;
          return (
            <button
              type="button"
              key={t.id}
              onClick={() => onChange(t.id)}
              className={`flex items-center justify-between text-left rounded-xl border-2 px-4 py-3 transition ${active ? "border-blue-600 bg-blue-50/40" : "border-slate-200 hover:border-slate-400"}`}
              data-testid={`template-option-${t.id}`}
            >
              <div>
                <div className="font-display font-semibold text-sm">{t.name}</div>
                <div className="text-xs text-slate-500 mt-0.5">{t.desc}</div>
              </div>
              {active && <CheckCircle2 className="w-5 h-5 text-blue-600 shrink-0" />}
            </button>
          );
        })}
      </div>

      <div className="text-xs uppercase tracking-widest text-slate-500 font-mono-display mt-6 mb-3">Accent color</div>
      <div className="grid grid-cols-6 gap-2" data-testid="accent-picker">
        {ACCENT_COLORS.map((c) => {
          const active = accentColor === c.hex;
          return (
            <button
              key={c.id}
              type="button"
              onClick={() => onAccentChange(c.hex)}
              title={c.name}
              className={`relative aspect-square rounded-lg border-2 transition ${active ? "border-slate-900 scale-105" : "border-slate-200 hover:border-slate-400"}`}
              style={{ background: c.hex }}
              data-testid={`accent-option-${c.id}`}
              aria-label={c.name}
            >
              {active && (
                <span className="absolute inset-0 flex items-center justify-center">
                  <CheckCircle2 className="w-4 h-4 text-white drop-shadow" />
                </span>
              )}
            </button>
          );
        })}
      </div>
      <div className="mt-3 text-xs text-slate-500">Used for section headers, name color, and rules.</div>
    </div>
  );
}
